<template>
  <div class="container">
    <a-row>
      <a-layout-content>
        <T1WelcomeSection />
        <T1MainSearcher />
        <T1Onas />
        <T1TopOffers />
        <T1ScrollOferty />
        <T1Przewodnik />
        <T1TopRegionyHome />
        <T1TravelplanetCta />
      </a-layout-content>
    </a-row>
  </div>
</template>

<script>
import T1Onas from "./T1Onas";
import T1TopRegionyHome from "./T1TopRegiony/T1TopRegionyHome";
import T1ScrollOferty from "./T1ScrollOferty";
import T1TopOffers from "./T1TopOffers";
import T1MainSearcher from "./T1Searchers/T1MainSearcher";
import T1WelcomeSection from "./T1WelcomeSection";
import T1TravelplanetCta from "./T1Assets/T1TravelplanetCta";
import T1Przewodnik from "./T1Przewodnik";

export default {
  name: "home-page-content",
  components: {
    T1Onas,
    T1TopRegionyHome,
    T1ScrollOferty,
    T1TopOffers,
    T1MainSearcher,
    T1WelcomeSection,
    T1TravelplanetCta,
    T1Przewodnik
  }
};
</script>
